import { Sparkles, Award, MessageSquare, TrendingUp } from "lucide-react";
import { Button } from "@/components/ui/button";
import { useNavigate } from "react-router-dom";

const FeaturesSection = () => {
  const navigate = useNavigate();

  const features = [
    { icon: Sparkles, text: "Access premium templates", highlight: "Access" },
    { icon: Award, text: "Get certified knowledge", highlight: "Get" },
    { icon: MessageSquare, text: "Connect with experts", highlight: "Connect" },
    { icon: TrendingUp, text: "Advance your career", highlight: "Advance" },
  ];

  return (
    <section className="py-12 lg:py-16 bg-background">
      <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8">
        {/* Dark Feature Card */}
        <div className="bg-[hsl(var(--hub-navy))] rounded-2xl p-6 lg:p-10 overflow-hidden">
          <div className="grid lg:grid-cols-2 gap-8 items-center">
            {/* Left Content */}
            <div>
              <h2 className="text-2xl sm:text-3xl lg:text-4xl font-bold text-white mb-4">
                Fast track your PM career
              </h2>
              <p className="text-gray-300 mb-6 text-base lg:text-lg">
                Get access to a variety of premium templates and resources from real-world experts.
              </p>

              {/* Feature List */}
              <ul className="space-y-4 mb-8">
                {features.map((feature, index) => (
                  <li key={index} className="flex items-center gap-3">
                    <div 
                      className={`w-8 h-8 rounded-full flex items-center justify-center ${
                        index === 0 ? 'bg-purple-500' :
                        index === 1 ? 'bg-teal-500' :
                        index === 2 ? 'bg-amber-500' :
                        'bg-blue-500'
                      }`}
                    >
                      <feature.icon className="h-4 w-4 text-white" />
                    </div>
                    <span className="text-white">
                      <span className="font-semibold">{feature.highlight}</span>
                      {" "}{feature.text.replace(feature.highlight, "").trim()}
                    </span>
                  </li>
                ))}
              </ul>

              <Button
                onClick={() => navigate("/templates")}
                variant="outline"
                className="bg-white text-foreground hover:bg-gray-100 border-0 font-semibold px-6"
              >
                Browse Templates
              </Button>
            </div>

            {/* Right - Image Collage */}
            <div className="hidden lg:grid grid-cols-2 gap-4">
              <div className="space-y-4">
                <div className="aspect-[3/4] rounded-xl bg-gradient-to-br from-blue-400 to-purple-500 opacity-80" />
              </div>
              <div className="space-y-4 pt-8">
                <div className="aspect-square rounded-xl bg-gradient-to-br from-purple-400 to-pink-500 opacity-80" />
                <div className="aspect-[4/3] rounded-xl bg-gradient-to-br from-teal-400 to-blue-500 opacity-80" />
              </div>
            </div>
          </div>
        </div>
      </div>
    </section>
  );
};

export default FeaturesSection;
